import React, { forwardRef } from 'react';
import ReactPlayer, { ReactPlayerProps } from 'react-player';

import { StyledReactPlayer } from './styles';

// ----------------------------------------------------------------------
// https://github.com/CookPete/react-player

interface PlayerProps extends ReactPlayerProps {
  styleOverride?: React.CSSProperties;
}

// to forward the ref to StyledReactPlayer
const Player = forwardRef<ReactPlayer, PlayerProps>(({ styleOverride, ...other }, ref) => (
  <StyledReactPlayer ref={ref} styleOverride={styleOverride} {...other} />
));
export default Player;
